import { useRef, useEffect } from "react";
import { throttle } from "lodash-es";

import { getAuthProvider } from "../../services/auth/providers";

const ACTIVITY_EVENTS = [
  "keydown",
  "mousemove",
  "mousedown",
  "scroll",
  "touchstart",
  "touchmove",
];

// Feeds the provider's idle gate in renewToken (shouldRenewInBackground).
//
// A provider that doesn't track activity (Entra, which renews unconditionally)
// gets no listeners: six listeners on every interaction would produce a value
// nothing reads. The ref still exists and simply stays at its mount time.
export function useUserActivity() {
  const lastActivityRef = useRef(Date.now());

  useEffect(() => {
    if (!getAuthProvider().tracksUserActivity) {
      return undefined;
    }

    const activityHandler = throttle(() => {
      lastActivityRef.current = Date.now();
    }, 60000); // Throttle to update at most once per minute

    ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, activityHandler, { passive: true });
    });

    return () => {
      ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, activityHandler);
      });
      activityHandler.cancel();
    };
  }, []);

  return lastActivityRef;
}
